type Behavior =
  | "Added to Cart"
  | "Viewed Product"
  | "Started Checkout"
  | "affirm payment info"
  | "flex payment info"

const ENABLE_HUBSPOT_EVENTS_IDENTITY = false

export const klaviyoIdentify = (
  email: string,
  firstName?: string,
  lastName?: string,
  allowMarketing?: boolean
) => {
  if (
    typeof window !== `undefined` &&
    getCookie("CookieConsent-s") === "true"
  ) {
    const _learnq = window._learnq || []
    _learnq.push([
      "identify",
      {
        $email: email,
        $first_name: firstName ? firstName : undefined,
        $last_name: lastName ? lastName : undefined,
        allow_marketing: allowMarketing ? "true" : undefined,
      },
    ])
  }
}

export const klaviyoIdentifyProps = (props: Record<string, string>) => {
  if (
    typeof window !== `undefined` &&
    getCookie("CookieConsent-s") === "true"
  ) {
    const _learnq = window._learnq || []
    _learnq.push(["identify", props])
  }
}

export const hubspotIdentify = (
  email: string,
  props: {
    firstName?: string
    lastName?: string
    otherProps?: Record<string, string>
  }
) => {
  if (
    ENABLE_HUBSPOT_EVENTS_IDENTITY &&
    typeof window !== `undefined` &&
    getCookie("CookieConsent-s") === "true"
  ) {
    var _hsq = (window._hsq = window._hsq || [])
    try {
      const identifyProps: Record<string, any> = {
        email: email,
      }

      if (props.firstName) {
        identifyProps.firstname = props.firstName
      }

      if (props.lastName) {
        identifyProps.lastname = props.lastName
      }

      if (props.otherProps) {
        Object.assign(identifyProps, props.otherProps)
      }

      console.log("Hubspot identify with props:", identifyProps)
      _hsq.push(["identify", identifyProps])

      // Track page view after identify to ensure contact is created/updated
      _hsq.push(["setPath", window.location.pathname])
      _hsq.push(["trackPageView"])
    } catch (e) {
      console.error("Hubspot identify error:", e)
    }
  }
}

export const hubspotTrackEvent = (
  event: string,
  properties: Record<string, any>
) => {
  if (
    ENABLE_HUBSPOT_EVENTS_IDENTITY &&
    typeof window !== `undefined` &&
    getCookie("CookieConsent-s") === "true"
  ) {
    var _hsq = (window._hsq = window._hsq || [])
    try {
      _hsq.push([
        "trackEvent",
        {
          id: event,
        },
      ])
    } catch (e) {
      console.error("Hubspot track event error:", e)
    }
  }
}

export const klaviyoTrackBehavior = (name: Behavior, item: Object) => {
  if (getCookie("CookieConsent-s") === "true" && window?._learnq) {
    const _learnq = window._learnq || []
    _learnq.push(["track", name, item])
  }
}

export const getCookie = (name: string) => {
  var nameEQ = name + "="
  var ca = document.cookie.split(";")
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) == " ") c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
  }
  return null
}
